var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.31952 6.31952C6.74555 5.89349 7.43627 5.89349 7.8623 6.31952L12 10.4564L16.1377 6.31952C16.531 5.92626 17.1498 5.89601 17.5777 6.22877L17.6805 6.31952C18.1065 6.74555 18.1065 7.43627 17.6805 7.8623L13.5436 12L17.6805 16.1377C18.0737 16.531 18.104 17.1498 17.7712 17.5777L17.6805 17.6805C17.2545 18.1065 16.5637 18.1065 16.1377 17.6805L12 13.5436L7.8623 17.6805C7.46904 18.0737 6.85025 18.104 6.42229 17.7712L6.31952 17.6805C5.89349 17.2545 5.89349 16.5637 6.31952 16.1377L10.4564 12L6.31952 7.8623C5.92626 7.46904 5.89601 6.85025 6.22877 6.42229L6.31952 6.31952Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.bc562163a71f0d7bff88950d3d10b52e.svg";
export { ForwardRef as ReactComponent };